import { render, staticRenderFns } from "./account-modal.vue?vue&type=template&id=157f3014&"
import script from "./account-modal.vue?vue&type=script&lang=js&"
export * from "./account-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports